import { render, staticRenderFns } from "./ReservationPrograms.vue?vue&type=template&id=5c775cc2&scoped=true"
import script from "./ReservationPrograms.vue?vue&type=script&lang=js"
export * from "./ReservationPrograms.vue?vue&type=script&lang=js"
import style0 from "./ReservationPrograms.vue?vue&type=style&index=0&id=5c775cc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c775cc2",
  null
  
)

export default component.exports